
import { useParams } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { EditPackageLoading } from "@/components/package/edit/EditPackageLoading";
import { EditPackageContent } from "@/components/package/edit/EditPackageContent";
import { useEditPackage } from "@/hooks/useEditPackage";

const EditPackage = () => {
  const { id } = useParams();
  
  if (!id) {
    return null;
  }

  const { packageData, isLoading } = useEditPackage(id);

  if (isLoading) {
    return <EditPackageLoading />;
  }

  return (
    <>
      <Header />
      <div className="container max-w-2xl mx-auto py-8 px-4">
        {packageData && <EditPackageContent packageData={packageData} />}
      </div>
      <Footer />
    </>
  );
};

export default EditPackage;
